<template>
    <div class="ChildRecord">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-md-2">
                    <div><img class="photo-border-square" v-bind:src="ProfilePhotoFileID" style="width:100%;border-radius:20px;" /></div>
                </div>
                <div class="col col-md-10">
                    <button type="button" class="close" v-on:click="CloseRecord"><span>x</span></button>
                    <h1><span>{{ ChildRecordData.Person.FirstName }}</span> <span v-if="ChildRecordData.Person.AKA">"{{ ChildRecordData.Person.AKA }}"</span> <span>{{ ChildRecordData.Person.LastName }}</span></h1>
                    <h4><span>DOB: </span><span>{{ formatDate(ChildRecordData.Person.DOB, 'MM/DD/YY') }}</span><span> Age: </span><span>{{ ChildRecordData.Person.AgeString }}</span></h4>
                    <h4><span>{{ ChildRecordData.SubProgramName }} </span><span>{{ formatDate(ChildRecordData.ClientProgramMembership.StartDate, 'MM/DD/YY') }}</span><span> - </span><span>{{ formatDate(ChildRecordData.ClientProgramMembership.EndDate, 'MM/DD/YY', 'Present') }}</span><span>{{ ChildRecordData.CurrentCensusProgramService ? ' (' + ChildRecordData.CurrentCensusProgramService + ')' : '' }}</span></h4>
                </div>
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col">
                    <div class="record-tabs">
                        <span class="d-none d-sm-block">
                            <b-nav>
                                <div v-for="pane in Panes">
                                    <div v-if="pane.name == 'Medication' && CheckPermission('Residential_Medication')">
                                        <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                    </div>
                                    <div v-else-if="pane.name != 'Medication'">
                                        <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                    </div>
                                </div>
                            </b-nav>
                        </span>
                        <b-nav>
                            <span class="d-sm-none">
                                <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                    <div v-for="pane in Panes">
                                        <div v-if="pane.name == 'Medication' && CheckPermission('Residential_Medication')">
                                            <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                        </div>
                                        <div v-else-if="pane.name != 'Medication'">
                                            <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                        </div>
                                    </div>
                                </b-nav-item-dropdown>
                            </span>
                        </b-nav>
                    </div>
                    <div class="tab-content">
                        <div v-show="PaneShown == 'Summary'">
                            <ChildSummary v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Child Info'">
                            <Information v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Program'">
                            <Program v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'People'">
                            <People v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'School'">
                            <School v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Behavior'">
                            <Behavior v-bind:child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Medication'" v-if="CheckPermission('Residential_Medication')">
                            <Medication :client-sub-program-membership-id="ChildRecordData.ClientProgramMembership.Id" />
                        </div>
                        <div v-show="PaneShown == 'Documents'">
                            <select class="form-control olive-green" v-model="DocumentView" style="margin-bottom: 10px; margin-top: 5px;">
                                <option value="NewDocument">New Document</option>
                                <option value="CaseFile">Case File</option>
                            </select>
                            <CaseFile v-show="DocumentView == 'CaseFile'"
                                      chart-type="ClientSubProgramMembership"
                                      :chart-record-id="ChildRecordData.ClientProgramMembership.Id" />
                            <NewDocument v-show="DocumentView == 'NewDocument'"
                                         :form-memberships="SubProgramFormMemberships"
                                         chart-type="ClientSubProgramMembership"
                                         :chart-record-id="ChildRecordData.ClientProgramMembership.Id" />
                        </div>
                        <div v-show="PaneShown == 'New Document'">
                            <NewDocument :form-memberships="SubProgramFormMemberships"
                                         :chart-record-id="ChildRecordData.ClientProgramMembership.Id" chart-type="ClientSubProgramMembership" />
                        </div>
                        <div v-show="PaneShown == 'Reports'">
                            <Reports :child-record-data="ChildRecordData" />
                        </div>
                        <div v-show="PaneShown == 'Log'">
                            <ClientServiceLog v-bind:child-record-data="ChildRecordData" :key="ChildRecordData.Id" />
                        </div>
                        <div v-show="PaneShown == 'Admin' && CheckPermission('Residential.Client.AdminPane')">
                            <Admin v-bind:child-record-data="ChildRecordData" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import Admin from "./Admin.vue";
    import CaseFile from "../../../Core/RecordComponents/CaseFile.vue";
    import Information from "./Information.vue";
    import NewDocument from "../../../Core/RecordComponents/NewDocument.vue";
    import ClientServiceLog from './ClientServiceLog.vue';
    import People from "./People.vue";
    import School from "./School.vue";
    import Program from "./Program.vue";
    import ChildSummary from "./Summary.vue";
    import Behavior from "./Behavior.vue";
    import Medication from "../../../Core/MedicationManagement/ClientPhysicianOrderList.vue";
    import Reports from "./Reports.vue";
    import { EventBus } from '../../../../services/event-bus.js';
    export default {
        props: [
            'ChildRecordData'
        ],
        created() {
            let vm = this;
            EventBus.$on('profile-update-needed', chartID => {
                if (chartID == vm.ChildRecordData.Id) {
                    vm.ProfilePhotoURL();
                }
            });

        },
        beforeDestroy() {
            EventBus.$off('profile-update-needed');
        },
        data: function () {
            return {
                PaneShown: "Summary",
                DocumentView: "NewDocument",
                ProfilePhotoFileID: this.ProfilePhotoURL()
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CloseRecord() {
                console.log("attempting close record from within child record");
                this.$parent.CloseRecord("Clients.ClientProfiles.Remove","ChildList",this.ChildRecordData.ClientProgramMembership.Id);
            },
            ProfilePhotoURL() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FosterClients/GetPhotoID", { membershipClientSubProgramID: this.ChildRecordData.Id }, this.ProfilePhotoURLSuccess, () => { }, false);
            },
            ProfilePhotoURLSuccess(response) {
                  if (response.data.data != null) {
                      this.ProfilePhotoFileID = this.$baseURL + '/API/Core/Files/GetFileContent/profilephoto?FileID=' + response.data.data;
                  }
                  else {
                      this.ProfilePhotoFileID = "/images/NoPhotoOnFile.jpg"
                  } 
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            Admin,
            CaseFile,
            Information,
            NewDocument,
            People,
            School,
            Program,
            ChildSummary,
            Behavior,
            Medication,
            Reports,
            ClientServiceLog
        },
        mounted() {
        },
        computed: {
            changeDropdownName: function () {
                return this.PaneShown;
            },
            SubProgramFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ChildRecordData.ClientProgramMembership.SubProgramID);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "ClientSubProgramMembership");
            },
            Panes: function () {
                let pList = [
                    { name: 'Summary' },
                    { name: 'Child Info' },
                    { name: 'Program' },
                    { name: 'People' },
                    { name: 'School' },
                    { name: 'Behavior' },
                    { name: 'Medication' },
                    { name: 'Documents' },
                    { name: 'Reports' }
                ];

                if (this.CheckPermission("ResidentialClientLogAccess")) {
                    pList.push({
                        name: 'Log'
                    });
                }

                pList.push({
                    name: 'Admin'
                });

                return pList;
            }
        },
    }
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }

    @media only screen and (max-width: 576px) {
        h4 {
            font-size: 1em;
        }

        h1 {
            font-size: 1.5em;
        }
    }
</style>